/**
 * Module: Smooth Scroll
 *
 * Add support for animated smooth scrolling to anchor tags
 */
export default angular.module('smoothScroll', ['duScroll'])
    /**
     * @ngdoc directive
     * @name smoothScroll.directive:smoothScroll
     * @restrict A
     * @description
     * Scrolls the user, slowly with animation, to the provided href="#id".
     * The duration of the vaule can be set by ms
     */
    // @ngInject
    .directive('smoothScroll', function ($document) {
        var DURATION = 1000;
        return {
            scope: true,
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var duration = parseInt(attrs.smoothScroll, 10) || DURATION;
                var id = attrs.href && attrs.href.replace('#', '') || null;
                var element = angular.element(document.getElementById(id));
                if (element.length) {
                    $element.on('click', function (e) {
                        e.preventDefault();
                        $document.scrollTo(element, 0, duration);
                        $element[0].blur();
                    });
                }
            }
        };
    });
